import { AppState, AppAction } from './types';

export const actionTypes = {
  SET_TEXT_SIZE: 'SET_TEXT_SIZE',
  TOGGLE_REDUCE_MOTION: 'TOGGLE_REDUCE_MOTION',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_USER_ROLE: 'SET_USER_ROLE',
  SET_USER_ROLE_PENDING: 'SET_USER_ROLE_PENDING',
  SET_USER_ROLE_SUCCESS: 'SET_USER_ROLE_SUCCESS',
  SET_USER_ROLE_FAILURE: 'SET_USER_ROLE_FAILURE',
  SET_CURRENT_SIMULATION: 'SET_CURRENT_SIMULATION',
  SET_CURRENT_SIMULATION_PENDING: 'SET_CURRENT_SIMULATION_PENDING',
  SET_CURRENT_SIMULATION_SUCCESS: 'SET_CURRENT_SIMULATION_SUCCESS',
  SET_CURRENT_SIMULATION_FAILURE: 'SET_CURRENT_SIMULATION_FAILURE',
  TOGGLE_HIGH_CONTRAST: 'TOGGLE_HIGH_CONTRAST',
  TOGGLE_DARK_MODE: 'TOGGLE_DARK_MODE',
  TOGGLE_SOUND: 'TOGGLE_SOUND',
  TOGGLE_VIBRATION: 'TOGGLE_VIBRATION',
  UPDATE_GLOBAL_SCORE: 'UPDATE_GLOBAL_SCORE',
  UPDATE_GLOBAL_SCORE_PENDING: 'UPDATE_GLOBAL_SCORE_PENDING',
  UPDATE_GLOBAL_SCORE_SUCCESS: 'UPDATE_GLOBAL_SCORE_SUCCESS',
  UPDATE_GLOBAL_SCORE_FAILURE: 'UPDATE_GLOBAL_SCORE_FAILURE',
  RESET_STATE: 'RESET_STATE',
} as const;

export const initialState: AppState = {
  textSize: 'medium',
  reduceMotion: false,
  language: 'es',
  userRole: null,
  currentSimulation: null,
  highContrast: false,
  darkMode: false,
  soundEnabled: true,
  vibrationEnabled: true,
  globalScore: 0,
  userRoleAsync: { isLoading: false, error: null },
  simulationAsync: { isLoading: false, error: null },
  scoreAsync: { isLoading: false, error: null },
};

export function appReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case actionTypes.SET_TEXT_SIZE:
      return { ...state, textSize: action.payload };
    case actionTypes.TOGGLE_REDUCE_MOTION:
      return { ...state, reduceMotion: !state.reduceMotion };
    case actionTypes.SET_LANGUAGE:
      return { ...state, language: action.payload };
    case actionTypes.SET_USER_ROLE:
      return { ...state, userRole: action.payload };
    case actionTypes.SET_USER_ROLE_PENDING:
      return { 
        ...state, 
        userRoleAsync: { isLoading: true, error: null } 
      };
    case actionTypes.SET_USER_ROLE_SUCCESS:
      return { 
        ...state, 
        userRole: action.payload,
        userRoleAsync: { isLoading: false, error: null } 
      };
    case actionTypes.SET_USER_ROLE_FAILURE:
      return { 
        ...state, 
        userRoleAsync: { isLoading: false, error: action.payload } 
      };
    case actionTypes.SET_CURRENT_SIMULATION:
      return { ...state, currentSimulation: action.payload };
    case actionTypes.SET_CURRENT_SIMULATION_PENDING:
      return { 
        ...state, 
        simulationAsync: { isLoading: true, error: null } 
      };
    case actionTypes.SET_CURRENT_SIMULATION_SUCCESS:
      return { 
        ...state, 
        currentSimulation: action.payload,
        simulationAsync: { isLoading: false, error: null } 
      };
    case actionTypes.SET_CURRENT_SIMULATION_FAILURE:
      return { 
        ...state, 
        simulationAsync: { isLoading: false, error: action.payload } 
      };
    case actionTypes.TOGGLE_HIGH_CONTRAST:
      return { ...state, highContrast: !state.highContrast };
    case actionTypes.TOGGLE_DARK_MODE:
      return { ...state, darkMode: !state.darkMode };
    case actionTypes.TOGGLE_SOUND:
      return { ...state, soundEnabled: !state.soundEnabled };
    case actionTypes.TOGGLE_VIBRATION:
      return { ...state, vibrationEnabled: !state.vibrationEnabled };
    case actionTypes.UPDATE_GLOBAL_SCORE:
      return { ...state, globalScore: state.globalScore + action.payload };
    case actionTypes.UPDATE_GLOBAL_SCORE_PENDING:
      return { 
        ...state, 
        scoreAsync: { isLoading: true, error: null } 
      };
    case actionTypes.UPDATE_GLOBAL_SCORE_SUCCESS:
      return { 
        ...state, 
        globalScore: state.globalScore + action.payload,
        scoreAsync: { isLoading: false, error: null } 
      };
    case actionTypes.UPDATE_GLOBAL_SCORE_FAILURE:
      return { 
        ...state, 
        scoreAsync: { isLoading: false, error: action.payload } 
      };
    case actionTypes.RESET_STATE:
      return {
        ...initialState,
        language: state.language,
        textSize: state.textSize,
        reduceMotion: state.reduceMotion,
        soundEnabled: state.soundEnabled,
        vibrationEnabled: state.vibrationEnabled,
        globalScore: state.globalScore,
      };
    default:
      return state;
  }
}
